export const formatterArray = array => {
  let result = "";
  for (var i = 0; i < array.length; i++) {
    result += "&t=" + array[i];
  }
  return result;
};
